import React from 'react';

export const PanelSettingsHeader = () => {
  return (
    <h2 className="text-sm font-semibold leading-[22px] text-wb-text-tertiary">
      PANEL SETTINGS
    </h2>
  );
};
